<template>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="dialogVisible" @close="onCancel" class="calcDialog" width="480px" append-to-body top="5%">
        <el-form ref="form" :model="formData" :rules="rules" label-position="left" label-width="120px" size="small">
            <idc-form-item :form="formData" :config="formConfig" col="24" />
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="onCancel">
                取 消
            </el-button>
            <el-button @click="onSubmit" type="primary">
                确 定
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import { store, mutation } from './data';
export default {
    props: {
        // 外部传入v-model,控制dialog的显示隐藏
        value: {
            type: Boolean,
            default: false
        },
        title: String,
        type: String,
        addLowerLevel: {
            type: Boolean,
            default: false
        },
        father: {
            type: null,
            default: ''
        },
        form: { Object, default: () => {} },
        formConfig: Array,
        node: { type: Object, default: () => {} },
        rulesData: { type: Object, default: () => {} }
    },
    data() {
        return {
            // 组件内部控制dialog显示隐藏
            dialogVisible: this.value,
            formData: this.form,
            // 表单验证
            rules: this.rulesData
        };
    },
    computed: {
        current() {
            return store.current || {};
        }
    },
    watch: {
        value(val) {
            if (!val) {
                return false;
            }
            if (this.node) {
                this.formData.brchParentId = this.node.data.id;
                this.formData.parentId = this.node.data.id;
            }
            if (this.type === 'modify') {
                this.$http.get(this.$attrs.urlData.info + this.node.data.id).then(res => {
                    if (res && res.data) {
                        this.formData = res.data;
                    }
                });
            } else {
                this.formData = {};
            }
            if (val === 'false') val = false;
            if (val === 'true') val = true;
            this.dialogVisible = val;
        }
    },
    created() {
        // this.$refs.form.resetFields();
        this.formData = {};
    },
    methods: {
        onCancel() {
            this.dialogVisible = false;
            this.$emit('edirCancal', false);
        },
        // 提交
        onSubmit() {
            const that = this;
            if (this.type === 'modify' && this.formData.leafYn && this.current.children.length > 0) {
                this.formData.leafYn = false;
                this.$message.warning('不能将含有子类的父级修改成叶子级');
                return;
            }
            this.$refs['form'].validate(valid => {
                if (valid) {
                    if (this.node && this.type !== 'modify') {
                        Object.assign(that.formData, { brchParentId: this.node.data.id }, { parentId: this.node.data.id });
                    }
                    this.$http.post(that.$attrs.urlData[that.type], that.formData).then(res => {
                        that.$emit('ok');
                        that.dialogVisible = false;
                        that.onCancel();
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.el-textarea__inner {
	/* line-height: 1!important; */
	/* border: 10px solid red!important; */
}
.el-form-item__content {
	padding: 40px 0 !important;
}
</style>
